import { ReactNode } from 'react';

import SectionBackground from '../../../assets/about/about-section-3-background.svg';
import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';
import { ScrollAnimationType } from '../../../enums/scroll-animation-type.enum';

import styles from './AboutRoyaltiesPlayersSection.module.scss';

interface IAboutRoyaltiesPlayersSectionProps {
  children: ReactNode;
}

const AboutRoyaltiesPlayersSection = ({ children }: IAboutRoyaltiesPlayersSectionProps) => {
  return (
    <div className={styles['section']}>
      {children}
      <ScrollInAnimationItem
        animationType={ScrollAnimationType.slideInBottomWithoutFade}
        className={styles['section-background-container']}
        threshold={0.3}
      >
        <img className={styles['section-background']} src={SectionBackground} alt="" width="1921" height="1002" />
      </ScrollInAnimationItem>
    </div>
  );
};

export default AboutRoyaltiesPlayersSection;
